import { SecurityProfileService } from "./../../service/securityProfile/securityProfile.service";
import { AuthenticationService } from "@alfresco/adf-core";
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from "@angular/common/http";
import { Component, EventEmitter, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import * as CryptoJS from "crypto-js";
import { environment } from "environments/environment";
import { Observable } from "rxjs/Observable";

import { PermissoesService } from "./../../service/usuario/permissoes.service";

declare var grecaptcha: any;
@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
})
export class LoginComponent implements OnInit {
  loginError = "";
  hide = true;
  errorAlert = false;
  apiURL = environment.API;
  apiURLPublic = environment.APIpublic;
  user: any;
  private usuarioAutenticado = false;
  public loginForm: FormGroup = new FormGroup({
    user: new FormControl("", Validators.required),
    senha: new FormControl("", Validators.required),
  });
  loading = false;
  basicAuth: any;
  mostrarMenuEmitter = new EventEmitter<boolean>();
  loged = false;
  asyncResult;
  x;
  y;
  deData;
  clienteId;

  keyCrypt: string = environment.keyCriptAttempts;
  attemptNumber: number = 0;
  recaptcha: any;

  public objectReturn: any = {
    entry: {
      id: null,
      userId: null,
    },
  };

  currentTime = new Date();
  currentYear = this.currentTime.getFullYear();

  newMessage: boolean = false;
  message: string = "";
  delay: any = 0;
  loginDataFormEmitter = new EventEmitter<{
    userId: string;
    password: string;
  }>();
  constructor(
    private fb: FormBuilder,
    private authService: AuthenticationService,
    private router: Router,
    private httpCliente: HttpClient,
    private permissionService: PermissoesService,
    private securityProfileService: SecurityProfileService
  ) {
    if (sessionStorage.getItem("delay") !== null) {
      this.startDelay(sessionStorage.getItem("delay"));
    } else {
      sessionStorage.removeItem("delay");
      this.delay = 0;
    }
  }

  async ngOnInit(): Promise<void> {
    this.attemptNumber = parseInt(await this.decryptNumber());

    this.loginForm = this.fb.group({
      user: ["", Validators.required],
      senha: ["", Validators.required],
    });

    this.metodo12();

    this.securityProfileService.valueChanged$.subscribe((newValue: any) => {
      if (!newValue || newValue.length <= 2) {
        this.attemptNumber = 2;
        this.initCaptcha();
      }
    });
  }

  async metodo12() {
    this.x = await this.metodo1(10);
    this.y = await this.metodo2(20);
  }

  metodo1(x: number): Promise<any> {
    return new Promise<any>((resolve) => {
      setTimeout(() => {
        resolve(x);
      }, 1000);
    });
  }

  metodo2(y: number): Promise<any> {
    return new Promise<any>((resolve) => {
      setTimeout(() => {
        resolve(y);
      }, 4000);
    });
  }

  login() {
    if (this.loginForm.valid) {
      this.loading = true;
      this.teste();
    } else {
      this.loginError = "Preencha o(s) Campo(s) Obrigatórios";
      this.showAlertExcluir();
    }
  }

  usuarioEstaAutenticado() {
    return this.usuarioAutenticado;
  }

  teste() {
    this.authService
      .login(
        this.loginForm.get("user").value,
        this.loginForm.get("senha").value
      )
      .subscribe(
        (data) => {
          this.doLogin(data.ticket);
          this.resetAttempts(this.loginForm.get("user").value);

          this.usuarioAutenticado = true;
          this.mostrarMenuEmitter.emit(true);
          this.loged = true;
        },
        (err) => {
          if (this.recaptcha) {
            // @ts-ignore
            grecaptcha.reset();
          }

          this.loading = false;
          this.mostrarMenuEmitter.emit(false);
          this.usuarioAutenticado = false;
          if (err.status === 403) {
            this.loading = false;
            this.message = "Usuário ou senha inválidos.";
            this.newMessage = true;
            setTimeout(() => {
              this.newMessage = false;
            }, 10000);
            this.setSecurityProfileById(this.loginForm.get("user").value);
          } else {
            this.loading = false;
            this.message =
              "PCdoc RM está fora do ar, tente novamente em instantes!";
            this.newMessage = true;
            setTimeout(() => {
              this.newMessage = false;
            }, 10000);
          }
          this.showAlertExcluir();
        }
      );
  }

  setSecurityProfileById(userId: string) {
    this.loading = true;
    this.securityProfileService.setSecurityProfileById(userId, "RM").subscribe({
      next: (data) => {
        if (data.message != "null") {
          this.loading = false;
          this.message = data.message;
          this.newMessage = true;
          setTimeout(() => {
            this.newMessage = false;
          }, 10000);
        } else {
          this.loading = false;
          this.message = data.message;
          this.newMessage = true;
          setTimeout(() => {
            this.newMessage = false;
          }, 10000);
        }

        if (data.delay > 0) {
          this.loading = false;
          (this.message =
            "Aguarde" +
            " " +
            data.delay +
            " " +
            "segundos, para tentar novamente"),
            (this.newMessage = true);
          this.loading = false;
          setTimeout(() => {
            this.newMessage = false;
          }, 10000);

          this.startDelay(data.delay);
        }
      },
      error: (err) => {
        if (this.recaptcha) {
          // @ts-ignore
          grecaptcha.reset();
        }

        this.loading = false;
        this.message = err.error.message;
        this.newMessage = true;
        setTimeout(() => {
          this.newMessage = false;
        }, 10000);
      },
    });
    this.encryptNumber();
  }

  startDelay(delay: any) {
    let seconds = delay;

    const setInter = setInterval(() => {
      if (seconds <= 0) {
        clearInterval(setInter);
        sessionStorage.removeItem("delay");
      } else {
        seconds--;
        sessionStorage.setItem("delay", seconds.toString());
        this.delay = seconds;
      }
    }, 1000);
  }

  resetAttempts(userName: string) {
    this.securityProfileService.resetAttempts(userName).subscribe({
      next: () => {},
      error: () => {},
    });
  }

  getUserNovo(userId: String, ticket: any, authorization: any) {
    this.permissionService.getUserNovo(userId, ticket, authorization).subscribe(
      (data) => {
        const arrayAuthority: any[] = [];
        this.user = data;
        this.user.forEach((el) => {
          arrayAuthority.push(el.authority);
        });
        this.setItemAuthority("authority", arrayAuthority);
        const params = sessionStorage.getItem("params");
        if (params !== null && params !== "undefined") {
          if (params.length < 20) {
            this.clienteId = params;
            this.getPermissionCliente(this.clienteId, ticket, authorization);
            this.verifyUser(this.loginForm.get("user").value, ticket);
          } else {
            this.clienteId = params;
            this.deData = CryptoJS.AES.decrypt(
              decodeURIComponent(this.clienteId),
              "pcdoc"
            );
            this.clienteId = JSON.parse(
              this.deData.toString(CryptoJS.enc.Utf8)
            );
            this.getPermissionCliente(this.clienteId, ticket, authorization);
            this.verifyUser(this.loginForm.get("user").value, ticket);
          }
        } else {
          this.verifyUser(this.loginForm.get("user").value, ticket);
        }
      },
      (err) => {
        this.changeUserPass(err.status, userId, ticket, authorization);
      }
    );
  }

  verifyUser(userId: string, ticketResponse: string) {
    this.getAuthBasic();
    this.loading = true;
    this.permissionService.verifyUser(userId).subscribe({
      next: (data) => {
        this.loading = false;

        if (data.userHasToChangePassword) {
          this.message =
            "Sua senha expirou. Redirecionando para troca de senha...";
          this.newMessage = true;
          setTimeout(() => {
            this.newMessage = false;
            this.redirectToResetPasswordPage();
          }, 5000);
          return;
        }

        if (data.userHasTwoFactorAuth) {
          return this.router.navigateByUrl(
            `/validate-code?userid=${userId}&r=RM&m=TWO_FACTOR&g=${CryptoJS.AES.encrypt(
              this.loginForm.get("senha").value,
              ticketResponse
            )}&t=${ticketResponse}`
          );
        }

        this.loged = true;
        this.getAuthBasic();
        this.resetAttempts(this.loginForm.get("user").value);
        this.setLastLogin(this.loginForm.get("user").value);
        this.loading = false;
        return this.redirect();
      },
      error: (error: HttpErrorResponse) => {
        if (this.recaptcha) {
          // @ts-ignore
          grecaptcha.reset();
        }
        this.loading = false;
        this.message = error.error
          ? error.error
          : "Ocorreu um erro ao verificar usuario, entre em contato com o suporte.";
        this.newMessage = true;
        setTimeout(() => {
          this.newMessage = false;
        }, 10000);
      },
    });
  }

  setLastLogin(userId: string) {
    this.permissionService.setLastLoginUser(userId).subscribe({
      next: () => {},
      error: () => {},
    });
  }

  changeUserPass(errStatus, userId, ticket, authorization) {
    const isLoggedAlfresco = this.authService.isLoggedIn();

    if (errStatus === 401 && isLoggedAlfresco) {
      this.permissionService
        .changeUserPassword(
          userId,
          this.loginForm.get("senha").value,
          ticket,
          isLoggedAlfresco
        )
        .subscribe(
          () => {
            this.getUserNovo(userId, ticket, authorization);
          },
          () => {
            if (this.recaptcha) {
              // @ts-ignore
              grecaptcha.reset();
            }
            this.loading = false;
          }
        );
    } else {
      this.loading = false;
    }
  }

  setItemAuthority(key, value) {
    const store: any = CryptoJS.AES.encrypt(
      JSON.stringify(value),
      localStorage.getItem("ticket-ECM")
    );
    return sessionStorage.setItem(key, store);
  }

  setRolesUserNovo() {
    this.permissionService.getUserLogado().subscribe(
      (data) => {
        const arrayAuthority: any[] = [];
        this.user = data;
        this.user.forEach((el) => {
          arrayAuthority.push(el.authority);
        });
        this.setItemAuthority("authority", arrayAuthority);
      },
      () => {}
    );
  }

  loginSpring() {
    const headers = new HttpHeaders().set(
      "ticket",
      sessionStorage.getItem("ticket-ECM")
    );

    this.httpCliente
      .post<Observable<any>>(
        this.apiURLPublic + "/login",
        {
          userId: this.loginForm.get("user").value,
          password: this.loginForm.get("senha").value,
        },
        {
          headers,
        }
      )
      .subscribe(
        () => {},
        () => {}
      );
  }

  doLogin(ticket: string) {
    const formLogin = new FormData();
    formLogin.append("userId", this.loginForm.get("user").value);
    formLogin.append("password", this.loginForm.get("senha").value);

    const headers = new HttpHeaders().set("ticket", ticket);

    this.getAuthBasic();

    this.httpCliente
      .post(this.apiURLPublic + "/get-user", formLogin, { headers })
      .subscribe(
        (data) => {
          this.getUserNovo(
            this.loginForm.get("user").value,
            ticket,
            this.basicAuth
          );
        },
        () => {
          this.loading = false;
        }
      );
  }

  canAccessApp() {
    if (!this.recaptcha && this.attemptNumber >= 2) {
      this.message = "Preencha o captcha";
      this.newMessage = true;
      setTimeout(() => {
        this.newMessage = false;
      }, 10000);
      return;
    }
    this.permissionService
      .verificarAcessoApp(this.loginForm.get("user").value)
      .subscribe(
        (data) => {
          if (data) {
            // tem permissao
            this.login();
          } else {
            if (this.recaptcha) {
              // @ts-ignore
              grecaptcha.reset();
            }
            // nao tem permissao
            this.message =
              "Você não possui permissão para acessar este aplicativo !";
            this.newMessage = true;
            setTimeout(() => {
              this.newMessage = false;
            }, 10000);
          }
        },
        () => {}
      );
    this.loading = false;
  }

  redirect() {
    this.getAuthBasic();
    const ticket = localStorage.getItem("ticket-ECM");
    const userId = localStorage.getItem("APS_USERNAME");
    sessionStorage.setItem("ticket-ECM", ticket);
    sessionStorage.setItem("ACS_USERNAME", userId);

    const pastRouter = sessionStorage.getItem("routerpast");
    if (pastRouter !== "/login" && pastRouter !== "/") {
      // this.router.navigate([`${pastRouter}`]);
      if (pastRouter === null) {
        window.location.href = "/home";
        // this.router.navigate(['/home']);
      } else {
        window.location.href = `${pastRouter}`;
        // this.router.navigate([`${pastRouter}`]);
      }
    } else {
      window.location.href = "/home";
      // this.router.navigate(['/home']);
    }
    sessionStorage.removeItem("routerpast");
  }

  redirectToResetPasswordPage() {
    window.location.href =
      environment.URL_SURFACE + "reset-password-request?cto=RM";
  }

  getAuthBasic() {
    this.basicAuth =
      "Basic " +
      window.btoa(
        this.loginForm.get("user").value +
          ":" +
          this.loginForm.get("senha").value
      );
    sessionStorage.setItem("tokenAuth", this.basicAuth);
  }

  showAlertExcluir(): void {
    // show box msg
    this.errorAlert = true;
    // wait 3 Seconds and hide
    setTimeout(
      function () {
        this.errorAlert = false;
      }.bind(this),
      4000
    );
  }

  getPermissionCliente(idCliente: number, ticket, tockenAuth) {
    const headers = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("ticket", ticket)
      .set("Authorization", tockenAuth);

    this.httpCliente
      .get<any>(
        this.apiURL + `/permission/get-permission-por-cliente/${idCliente}`,
        { headers }
      )
      .subscribe(
        (data) => {
          const arrayAuthorityCliente: any[] = [];
          data.forEach((el) => {
            arrayAuthorityCliente.push(el.authority);
          });
          this.setItemAuthority("authority-Empresa", arrayAuthorityCliente);
        },
        (err) => {
          this.loading = false;
          if (err.status === 401) {
            this.loading = false;
          }
        }
      );
  }

  initCaptcha() {
    // @ts-ignore
    this.recaptcha = grecaptcha.ready((el: any) => {
      // @ts-ignore
      grecaptcha.render("captcha", {
        sitekey: environment.siteKeyCapctha,
        callback: () => {
          this.recaptcha = true;
        },
        "expired-callback": () => {
          this.recaptcha = false;
        },
      });
    });
  }

  async encryptNumber() {
    let attempt: any = await this.decryptNumber();

    this.attemptNumber = parseInt(attempt);
    this.attemptNumber++;

    const encrypted = CryptoJS.AES.encrypt(
      this.attemptNumber.toString(),
      this.keyCrypt
    );

    sessionStorage.setItem("attempt", encrypted.toString());
  }

  async decryptNumber(): Promise<string> {
    this.initCaptcha();

    let attempt: any = sessionStorage.getItem("attempt");

    if (attempt === null) {
      attempt = CryptoJS.AES.encrypt("0", this.keyCrypt);
    }

    const decrypted = CryptoJS.AES.decrypt(attempt, this.keyCrypt);

    const decryptedString = decrypted.toString(CryptoJS.enc.Utf8);

    return decryptedString;
  }

  hidePassword(event: any) {
    if (event.pointerType != "mouse") {
      return true;
    } else {
      return false;
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/login/login.component.ts